import apisauce, {PROBLEM_CODE} from "apisauce";
import {AxiosRequestConfig} from "axios";

export const HANDLED_PROBLEMS: PROBLEM_CODE[] = [
  apisauce.CLIENT_ERROR,
  apisauce.SERVER_ERROR,
];

export const LOGGED_PROBLEMS: PROBLEM_CODE[] = [
  apisauce.SERVER_ERROR,
  apisauce.CONNECTION_ERROR,
  apisauce.NETWORK_ERROR,
  apisauce.TIMEOUT_ERROR,
  apisauce.UNKNOWN_ERROR,
];

export enum AUTH_ERROR_STATUS {
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
}

export const IGNORED_RESPONSE_STATUSES = [
  400,
  404,
  409,
  412, // Pcc is disabled
  422,
  429, // PccRequestLimitReached
  1400, // offline mode
];

export type Config = {
  getToken: () => Promise<string>;
  setToken: (token: string) => void;
  /**
   * The UNAUTHORIZED status has a common handler, we might want to skip it when some route wants to have custom handling
   */
  skipUnauthorizedHandling?: (config: AxiosRequestConfig) => boolean;
  logout: () => void;
};

export type ApiErrorData = Readonly<{
  status: number;
  message: string;
  timestamp: number;
  exception: string;
  path: string;
}>;
